import { isValidDate } from '@/utils/date'

export function format(
    date: string | Date,
    options: Intl.DateTimeFormatOptions = {
        month: 'long',
        day: 'numeric',
    }
): string {
    if (!date) {
        return ''
    }

    const dateObj = new Date(date)

    if (!isValidDate(dateObj)) {
        return ''
    }

    if (dateObj.getFullYear() !== new Date().getFullYear()) {
        options.year = 'numeric'
    }

    return dateObj.toLocaleDateString('bg-BG', options)
}

export function createTimelessDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

export type Weekday = 1 | 2 | 4 | 8 | 16 | 32 | 64

export const DAYS_NONE = 0
export const MONDAY: Weekday = 1
export const TUESDAY: Weekday = 2
export const WEDNESDAY: Weekday = 4
export const THURSDAY: Weekday = 8
export const FRIDAY: Weekday = 16
export const SATURDAY: Weekday = 32
export const SUNDAY: Weekday = 64
export const DAYS_ALL = 127

const days = [SUNDAY, MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY, SATURDAY]

const isAllowedWeekday = (allowedWeekdays: number, weekday: Weekday): boolean =>
    (allowedWeekdays & weekday) > 0

export const isAllowedWeekdayDate = (
    allowedWeekdays: number,
    date: Date
): boolean => {
    const day = days[date.getDay()]
    if (!day) {
        return false
    }

    return isAllowedWeekday(allowedWeekdays, day)
}
